import { apiClient } from './apiClient';
import type { TransphereIndicatorDto } from '../types/transphere/transphereIndicator';
import type { TransphereUnsentInvoicesDto } from '../types/transphere/transphereUnsentInvoices';

/** Which step of the encaissement subscription review an inactive encaissement is stuck at. */
export type EncaissementInProgressStatus = 'processing' | 'pending' | 'incomplete' | 'rejected';

export interface TransphereStatusDto {
    subscribed: boolean;
    encaissementActive: boolean;
    encaissementInProgressStatus?: EncaissementInProgressStatus | null;
}

export const transphereService = {
    // Null when there is no indicator to show: the server replies 204 No Content, which apiClient
    // surfaces as undefined.
    getIndicator: async (): Promise<TransphereIndicatorDto | null> =>
        (await apiClient.get<TransphereIndicatorDto>('/transphere/indicator')) ?? null,

    // Null when nothing has been waiting long enough, or the company has no Transphere invoicing. One
    // endpoint for both paths: cloud counts live from Acomba GO, desktop reads the count taken at sync.
    getUnsentInvoices: async (): Promise<TransphereUnsentInvoicesDto | null> =>
        (await apiClient.get<TransphereUnsentInvoicesDto>('/transphere/unsent-invoices')) ?? null,

    getStatus: (forceRefresh = false): Promise<TransphereStatusDto> =>
        apiClient.get<TransphereStatusDto>(`/company/transphere-status${forceRefresh ? '?refresh=true' : ''}`),

    // Records the general-history entry for a batch of Transphere payments applied in AcombaGO. Both
    // counts are the batch AcombaGO reported: distinct customers touched and invoice rows applied.
    recordPaymentsApplied: (customersUpdated: number, invoicesApplied: number): Promise<void> =>
        apiClient.post<void>('/transphere/payments-applied', { customersUpdated, invoicesApplied }),
};
